import React from 'react'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import { TEST_MODULE_CHITIET_ROUTE_PATH } from '@/modules/test-module-chitiet/constants'

/** Mục con trong menu Hệ thống — bản clone DEV TEST để code tiếp. */
export const testModuleChiTietMenuItem = {
  id: 'testModuleChiTietMenu',
  to: TEST_MODULE_CHITIET_ROUTE_PATH,
  labelKey: 'components.menu.testModuleChiTiet',
  icon: <AccountTreeOutlinedIcon sx={{ fontSize: 18 }} />,
}
